import { render, staticRenderFns } from "./LoaderFull.vue?vue&type=template&id=65a9612e&scoped=true&"
import script from "./LoaderFull.vue?vue&type=script&lang=js&"
export * from "./LoaderFull.vue?vue&type=script&lang=js&"
import style0 from "./LoaderFull.vue?vue&type=style&index=0&id=65a9612e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9612e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCubeAnimation: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/icons/CubeAnimation.vue').default})
